import { SVG_ENUM } from "enums";
import { lazy, Suspense } from "react";

const EyeSVG = lazy(() => import("assets/svg/EyeSVG"));
const CrossedEyeSVG = lazy(() => import("assets/svg/CrossedEyeSVG"));
const CloseSVG = lazy(() => import("assets/svg/CloseSVG"));
const CloseCircleSVG = lazy(() => import("assets/svg/CloseCircleSVG"));
const ChevronUpSVG = lazy(() => import("assets/svg/ChevronUpSVG"));
const ChevronDownSVG = lazy(() => import("assets/svg/ChevronDownSVG"));
const ChevronSVG = lazy(() => import("assets/svg/ChevronSVG"));
const CheckedSVG = lazy(() => import("assets/svg/CheckedSVG"));
const BackChevronSVG = lazy(() => import("assets/svg/BackChevronSVG"));
const AcceptGreenSVG = lazy(() => import("assets/svg/AcceptGreenSVG"));
const LoginBGDesktopSVG = lazy(() => import("assets/svg/LoginBGDesktopSVG"));
const LoginBGMobileSVG = lazy(() => import("assets/svg/LoginBGMobileSVG"));
const LogoSVG = lazy(() => import("assets/svg/LogoSVG"));
const LogoWhiteSVG = lazy(() => import("assets/svg/LogoWhiteSVG"));
const ArrowLeftSVG = lazy(() => import("assets/svg/ArrowLeftSVG"));
const ArrowLongSVG = lazy(() => import("assets/svg/ArrowLongSVG"));
const WarningCloudSVG = lazy(() => import("assets/svg/WarningCloudSVG"));
const AnnouncementSVG = lazy(() => import("assets/svg/AnnouncementSVG"));
const ArrowReloadSVG = lazy(() => import("assets/svg/ArrowReloadSVG"));
const ArrowUndoSVG = lazy(() => import("assets/svg/ArrowUndoSVG"));
const CalendarSVG = lazy(() => import("assets/svg/CalendarSVG"));
const CloudDownloadSVG = lazy(() => import("assets/svg/CloudDownloadSVG"));
const CreditCardSVG = lazy(() => import("assets/svg/CreditCardSVG"));
const EditSVG = lazy(() => import("assets/svg/EditSVG"));
const FileSVG = lazy(() => import("assets/svg/FileSVG"));
const FileDownloadSVG = lazy(() => import("assets/svg/FileDownloadSVG"));
const InfoSVG = lazy(() => import("assets/svg/InfoSVG"));
const LockSVG = lazy(() => import("assets/svg/LockSVG"));
const LinkSVG = lazy(() => import("assets/svg/LinkSVG"));
const ListUnorderedSVG = lazy(() => import("assets/svg/ListUnorderedSVG"));
const LogoutSVG = lazy(() => import("assets/svg/LogoutSVG"));
const PresentationSVG = lazy(() => import("assets/svg/PresentationSVG"));
const RelianceSVG = lazy(() => import("assets/svg/RelianceSVG"));
const SearchSVG = lazy(() => import("assets/svg/SearchSVG"));
const StopSignSVG = lazy(() => import("assets/svg/StopSignSVG"));
const TrashSVG = lazy(() => import("assets/svg/TrashSVG"));
const UserGroupSVG = lazy(() => import("assets/svg/UsersGroupSVG"));
const UserSVG = lazy(() => import("assets/svg/UserSVG"));
const TicketSVG = lazy(() => import("assets/svg/TicketSVG"));
const FilesSVG = lazy(() => import("assets/svg/FilesSVG"));
const FilesCheckSVG = lazy(() => import("assets/svg/FilesCheckSVG"));
const ShieldSVG = lazy(() => import("assets/svg/ShieldSVG"));
const UsersSVG = lazy(() => import("assets/svg/UsersSVG"));
const RedClockSVG = lazy(() => import("assets/svg/RedClockSVG"));
const SuccessorsFractalSVG = lazy(
  () => import("assets/svg/SuccessorsFractalSVG"),
);
const SuccessorSVG = lazy(() => import("assets/svg/SuccessorSVG"));
const DashboardBGDesktopSVG = lazy(
  () => import("assets/svg/DashboardBGDesktopSVG"),
);
const DashboardBGMobileSVG = lazy(
  () => import("assets/svg/DashboardBGMobileSVG"),
);
const DotsSVG = lazy(() => import("assets/svg/DotsSVG"));
const PINSVG = lazy(() => import("assets/svg/PinSVG"));
const CheckVerifiedSVG = lazy(() => import("assets/svg/CheckVerifiedSVG"));
const CircleCheckSVG = lazy(() => import("assets/svg/CircleCheckSVG"));
const CircleCheckedGreenSVG = lazy(
  () => import("assets/svg/CircleCheckedGreenSVG"),
);
const AwardSVG = lazy(() => import("assets/svg/AwardSVG"));
const UserCircleSVG = lazy(() => import("assets/svg/UserCircleSVG"));
const CalendarDaysSVG = lazy(() => import("assets/svg/CalendarDaysSVG"));
const CloudUploadSVG = lazy(() => import("assets/svg/CloudUploadSVG"));
const CloseCircleGraySVG = lazy(() => import("assets/svg/CloseCircleGraySVG"));
const CoinsHandSVG = lazy(() => import("assets/svg/CoinsHandSVG"));
const CardSVG = lazy(() => import("assets/svg/CardSVG"));
const HomepageHeroBackgroundSVG = lazy(
  () => import("assets/svg/HomepageHeroBackgroundSVG"),
);
const WalletSVG = lazy(() => import("assets/svg/WalletSVG"));
const UsersCheckSVG = lazy(() => import("assets/svg/UsersCheckSVG"));
const PresentationChartSVG = lazy(
  () => import("assets/svg/PresentationChartSVG"),
);
const NotificationTextSVG = lazy(
  () => import("assets/svg/NotificationTextSVG"),
);
const LineChartUpSVG = lazy(() => import("assets/svg/LineChartUpSVG"));
const NewsBarsSVG = lazy(() => import("assets/svg/NewsBarsSVG"));
const AnnotationAlertSVG = lazy(() => import("assets/svg/AnnotationAlertSVG"));
const FilterSVG = lazy(() => import("assets/svg/FilterSVG"));
const EPSuccess = lazy(() => import("assets/svg/EPSuccessSVG"));
const EPFail = lazy(() => import("assets/svg/EPFailSVG"));
const Logout2SVG = lazy(() => import("assets/svg/Logout2SVG"));
const CommunicationSVG = lazy(() => import("assets/svg/CommunicationSVG"));
const YourInvestitionsBackgroundSVG = lazy(
  () => import("assets/svg/YourInvestitionsBackgroundSVG"),
);
const MessageDotsCircleSVG = lazy(
  () => import("assets/svg/MessageDotsCircleSVG"),
);
const AddPlusSVG = lazy(() => import("assets/svg/AddPlusSVG"));
const ClockSVG = lazy(() => import("assets/svg/ClockSVG"));
const PhoneSVG = lazy(() => import("assets/svg/PhoneSVG"));
const XSquareSVG = lazy(() => import("assets/svg/XSquareSVG"));
const XSVG = lazy(() => import("assets/svg/XSVG"));
const LinkdSVG = lazy(() => import("assets/svg/LinkdSVG"));
const FBSVG = lazy(() => import("assets/svg/FbSVG"));
const IGSVG = lazy(() => import("assets/svg/IgSVG"));
// Asset Types
const StocksSVG = lazy(() => import("assets/svg/StocksSVG"));
const SharesSVG = lazy(() => import("assets/svg/SharesSVG"));
const RealEstateSVG = lazy(() => import("assets/svg/RealEstateSVG"));
const CryptoSVG = lazy(() => import("assets/svg/CryptoSVG"));
const PreciousStonesSVG = lazy(() => import("assets/svg/PreciousStonesSVG"));
const PreciousMetalsSVG = lazy(() => import("assets/svg/PreciousMetalsSVG"));
const TreasuryBondsSVG = lazy(() => import("assets/svg/TreasuryBondsSVG"));
const ArtworkSVG = lazy(() => import("assets/svg/ArtworkSVG"));
const InvestmentPolicySVG = lazy(
  () => import("assets/svg/InvestmentPolicySVG"),
);
const LoansSVG = lazy(() => import("assets/svg/LoansSVG"));
const CurrenciesSVG = lazy(() => import("assets/svg/CurrenciesSVG"));
const OtherAssetSVG = lazy(() => import("assets/svg/OtherAssetSVG"));
const DragHandleSVG = lazy(() => import("assets/svg/DragHandleSVG"));
const GoogleSVG = lazy(() => import("assets/svg/GoogleSVG"));
const AppleSVG = lazy(() => import("assets/svg/AppleSVG"));
const LoginOptionsSVG = lazy(() => import("assets/svg/LoginOptionsSVG"));

type P = {
  type: SVG_ENUM;
  className?: string;
};

const SVG = ({ type, className = "" }: P) => {
  const getSvg = () => {
    switch (type) {
      case SVG_ENUM.X_ICON:
        return <XSVG className={className} />;
      case SVG_ENUM.LINKD_ICON:
        return <LinkdSVG className={className} />;
      case SVG_ENUM.FB_ICON:
        return <FBSVG className={className} />;
      case SVG_ENUM.IG_ICON:
        return <IGSVG className={className} />;
      case SVG_ENUM.LOGO:
        return <LogoSVG className={className} />;
      case SVG_ENUM.LOGO_WHITE:
        return <LogoWhiteSVG className={className} />;
      case SVG_ENUM.EYE:
        return <EyeSVG className={className} />;
      case SVG_ENUM.CROSSED_EYE:
        return <CrossedEyeSVG className={className} />;
      case SVG_ENUM.CLOSE:
        return <CloseSVG className={className} />;
      case SVG_ENUM.CLOSE_CIRCLE:
        return <CloseCircleSVG className={className} />;
      case SVG_ENUM.CHEVRON_UP:
        return <ChevronUpSVG className={className} />;
      case SVG_ENUM.CHEVRON_DOWN:
        return <ChevronDownSVG className={className} />;
      case SVG_ENUM.CHECKED:
        return <CheckedSVG className={className} />;
      case SVG_ENUM.BACK_CHEVRON:
        return <BackChevronSVG className={className} />;
      case SVG_ENUM.ACCEPT_GREEN:
        return <AcceptGreenSVG className={className} />;
      case SVG_ENUM.LOGIN_BG_DESKTOP:
        return <LoginBGDesktopSVG className={className} />;
      case SVG_ENUM.LOGIN_BG_MOBILE:
        return <LoginBGMobileSVG className={className} />;
      case SVG_ENUM.ARROW_LEFT:
        return <ArrowLeftSVG className={className} />;
      case SVG_ENUM.ANNOUCEMENT:
        return <AnnouncementSVG className={className} />;
      case SVG_ENUM.ARROW_RELOAD:
        return <ArrowReloadSVG className={className} />;
      case SVG_ENUM.ARROW_UNDO:
        return <ArrowUndoSVG className={className} />;
      case SVG_ENUM.CALENDAR:
        return <CalendarSVG className={className} />;
      case SVG_ENUM.CLOUD_DOWNLOAD:
        return <CloudDownloadSVG className={className} />;
      case SVG_ENUM.CREDIT_CARD:
        return <CreditCardSVG className={className} />;
      case SVG_ENUM.EDIT:
        return <EditSVG className={className} />;
      case SVG_ENUM.FILE:
        return <FileSVG className={className} />;
      case SVG_ENUM.FILE_DOWNLOAD:
        return <FileDownloadSVG className={className} />;
      case SVG_ENUM.INFO:
        return <InfoSVG className={className} />;
      case SVG_ENUM.LOCK:
        return <LockSVG className={className} />;
      case SVG_ENUM.LINK:
        return <LinkSVG className={className} />;
      case SVG_ENUM.LIST_UNORDERED:
        return <ListUnorderedSVG className={className} />;
      case SVG_ENUM.LOGOUT:
        return <LogoutSVG className={className} />;
      case SVG_ENUM.PRESENTATION:
        return <PresentationSVG className={className} />;
      case SVG_ENUM.RELIANCE:
        return <RelianceSVG className={className} />;
      case SVG_ENUM.SEARCH:
        return <SearchSVG className={className} />;
      case SVG_ENUM.STOP_SIGN:
        return <StopSignSVG className={className} />;
      case SVG_ENUM.TRASH:
        return <TrashSVG className={className} />;
      case SVG_ENUM.USER_GROUP:
        return <UserGroupSVG className={className} />;
      case SVG_ENUM.USER:
        return <UserSVG className={className} />;
      case SVG_ENUM.DASHBOARD_BG_DESKTOP:
        return <DashboardBGDesktopSVG className={className} />;
      case SVG_ENUM.DASHBOARD_BG_MOBILE:
        return <DashboardBGMobileSVG className={className} />;
      case SVG_ENUM.DOTS:
        return <DotsSVG className={className} />;
      case SVG_ENUM.PIN:
        return <PINSVG className={className} />;
      case SVG_ENUM.CHECK_VERIFIED:
        return <CheckVerifiedSVG className={className} />;
      case SVG_ENUM.CIRCLE_CHECK:
        return <CircleCheckSVG className={className} />;
      case SVG_ENUM.CIRCLE_CHECKED_GREEN:
        return <CircleCheckedGreenSVG className={className} />;
      case SVG_ENUM.AWARD:
        return <AwardSVG className={className} />;
      case SVG_ENUM.CALENDAR_DAYS:
        return <CalendarDaysSVG className={className} />;
      case SVG_ENUM.CLOUD_UPLOAD:
        return <CloudUploadSVG className={className} />;
      case SVG_ENUM.CLOSE_CIRCLE_GRAY:
        return <CloseCircleGraySVG className={className} />;
      case SVG_ENUM.COINS_HAND:
        return <CoinsHandSVG className={className} />;
      case SVG_ENUM.CARD:
        return <CardSVG className={className} />;
      case SVG_ENUM.HOMEPAGE_HERO_BACKGROUND:
        return <HomepageHeroBackgroundSVG className={className} />;
      case SVG_ENUM.WALLET:
        return <WalletSVG className={className} />;
      case SVG_ENUM.USERS_CHECK:
        return <UsersCheckSVG className={className} />;
      case SVG_ENUM.PRESENTATION_CHART:
        return <PresentationChartSVG className={className} />;
      case SVG_ENUM.NOTIFICATION_TEXT:
        return <NotificationTextSVG className={className} />;
      case SVG_ENUM.LINE_CHART_UP:
        return <LineChartUpSVG className={className} />;
      case SVG_ENUM.NEWS_BARS:
        return <NewsBarsSVG className={className} />;
      case SVG_ENUM.ANNOTATION_ALERT:
        return <AnnotationAlertSVG className={className} />;
      case SVG_ENUM.FILTER:
        return <FilterSVG className={className} />;
      case SVG_ENUM.EP_SUCCESS:
        return <EPSuccess className={className} />;
      case SVG_ENUM.EP_FAIL:
        return <EPFail className={className} />;
      case SVG_ENUM.LOGOUT_2:
        return <Logout2SVG className={className} />;
      case SVG_ENUM.COMMUNICATION:
        return <CommunicationSVG className={className} />;
      case SVG_ENUM.MESSAGE_DOT_CIRCLE:
        return <MessageDotsCircleSVG className={className} />;
      case SVG_ENUM.ADD_PLUS:
        return <AddPlusSVG className={className} />;
      case SVG_ENUM.X_SQUARE:
        return <XSquareSVG className={className} />;
      case SVG_ENUM.YOUR_INVESTITIONS_BACKGROUND:
        return <YourInvestitionsBackgroundSVG className={className} />;
      case SVG_ENUM.USER_CIRCLE:
        return <UserCircleSVG className={className} />;
      case SVG_ENUM.SHIELD:
        return <ShieldSVG className={className} />;
      case SVG_ENUM.USERS:
        return <UsersSVG className={className} />;
      case SVG_ENUM.SUCCESSORS_FRACTALS:
        return <SuccessorsFractalSVG className={className} />;
      case SVG_ENUM.TICKET:
        return <TicketSVG className={className} />;
      case SVG_ENUM.FILES:
        return <FilesSVG className={className} />;
      case SVG_ENUM.FILES_CHECK:
        return <FilesCheckSVG className={className} />;
      case SVG_ENUM.SUCCESSOR:
        return <SuccessorSVG className={className} />;
      case SVG_ENUM.CLOCK:
        return <ClockSVG className={className} />;
      case SVG_ENUM.PHONE:
        return <PhoneSVG className={className} />;
      case SVG_ENUM.ARROW_LONG:
        return <ArrowLongSVG className={className} />;
      case SVG_ENUM.WARNING_CLOUD:
        return <WarningCloudSVG className={className} />;
      case SVG_ENUM.CHEVRON:
        return <ChevronSVG className={className} />;
      case SVG_ENUM.RED_CLOCK:
        return <RedClockSVG className={className} />;
      // Asset Types
      case SVG_ENUM.STOCKS:
        return <StocksSVG className={className} />;
      case SVG_ENUM.SHARES:
        return <SharesSVG className={className} />;
      case SVG_ENUM.REAL_ESTATE:
        return <RealEstateSVG className={className} />;
      case SVG_ENUM.CRYPTO:
        return <CryptoSVG className={className} />;
      case SVG_ENUM.PRECIOUS_STONES:
        return <PreciousStonesSVG className={className} />;
      case SVG_ENUM.PRECIOUS_METALS:
        return <PreciousMetalsSVG className={className} />;
      case SVG_ENUM.TREASURY_BONDS:
        return <TreasuryBondsSVG className={className} />;
      case SVG_ENUM.ARTWORK:
        return <ArtworkSVG className={className} />;
      case SVG_ENUM.INVESTMENT_POLICY:
        return <InvestmentPolicySVG className={className} />;
      case SVG_ENUM.LOANS:
        return <LoansSVG className={className} />;
      case SVG_ENUM.CURRENCIES:
        return <CurrenciesSVG className={className} />;
      case SVG_ENUM.OTHER_ASSET:
        return <OtherAssetSVG className={className} />;
      case SVG_ENUM.DRAG_HANDLE:
        return <DragHandleSVG className={className} />;
      case SVG_ENUM.GOOGLE_ICON:
        return <GoogleSVG className={className} />;
      case SVG_ENUM.APPLE_ICON:
        return <AppleSVG className={className} />;
      case SVG_ENUM.LOGIN_OPTIONS:
        return <LoginOptionsSVG className={className} />;
      default:
        return null;
    }
  };

  return <Suspense fallback="">{getSvg()}</Suspense>;
};

export default SVG;
